import { $, component$, useOnDocument, useSignal } from "@builder.io/qwik";
import { IS_MOBILE_DEVICE_REGEX, IS_SMARTPHONE_REGEX } from "./constants";

export const AdvGptBoxMobileContainer = component$<{ index: number }>(
  ({ index }) => {
    const isMobile = useSignal(false);
    const renderBox = useSignal(true);

    useOnDocument(
      "DOMContentLoaded",
      $(() => {
        isMobile.value =
          IS_SMARTPHONE_REGEX.test(navigator.userAgent) ||
          IS_MOBILE_DEVICE_REGEX.test(navigator.userAgent.substring(0, 4));
        const renderAtWidthListener = () => {
          if (!isMobile.value) return;
          if (document.documentElement.clientWidth > 500) {
            renderBox.value = false;
            window.removeEventListener("resize", renderAtWidthListener);
          }
        };
        window.addEventListener("resize", renderAtWidthListener);
      }),
    );

    if (!isMobile.value || !renderBox.value) return null;

    return (
      <div class="sgtv-mobile-adv-hidden sgtv-relative sgtv-inline-block sgtv-w-full sgtv-text-center">
        <div id={`adv-gpt-box-mobile-container${index}`}></div>
      </div>
    );
  },
);
